import React from 'react';

import { EmptyState } from '@ergeon/core-components';
import { ExclamationTriangleIcon } from '@ergeon/icons/hero/outline';

export const CallNotFoundEmptyState = () => (
  <div className="flex flex-col flex-grow justify-center items-center p-12 w-full">
    <EmptyState
      description="The call you're looking for doesn't exist or could not be loaded."
      icon={<ExclamationTriangleIcon />}
      title="Call not found" />
  </div>
);
